import React, { Component } from "react";
import { Card, CardBody, Row, Col, Badge } from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import { AddCommaNumber } from "../../../helpers/Utils";

class EcommerceAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: {
        shopee: { order_count: 0, total_revenue: 0 },
        tiktok: { order_count: 0, total_revenue: 0 },
        total: { order_count: 0, total_revenue: 0 },
      },
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate
    ) {
      this.loadData();
    }
  }

  loadData = async () => {
    try {
      this.setState({ loading: true });
      const user_id = localStorage.getItem("b");
      const { startDate, endDate } = this.props;

      const response = await axios.get(
        `${END_POINT}/api/analytics/ecommerce/summary?user_id=${user_id}` +
          (startDate ? `&start_date=${startDate}` : "") +
          (endDate ? `&end_date=${endDate}` : ""),
      );

      this.setState({
        data: response.data.data || this.state.data,
        loading: false,
      });
    } catch (err) {
      console.error("Error loading ecommerce analytics:", err);
      this.setState({ loading: false });
    }
  };

  formatPrice = (price) => {
    return AddCommaNumber(Math.round(price || 0)) + "đ";
  };

  render() {
    const { loading, data } = this.state;

    if (loading) {
      return (
        <Card className="mb-4">
          <CardBody className="text-center py-5">
            <div className="loading" />
          </CardBody>
        </Card>
      );
    }

    return (
      <Card className="mb-4">
        <CardBody>
          <h5 className="mb-4">
            <i className="simple-icon-basket mr-2" />
            Thống kê sàn TMĐT
          </h5>

          <Row>
            {/* Shopee */}
            <Col md="4" className="mb-3">
              <div
                className="p-3 bg-shopee-soft"
                style={{
                  borderRadius: "8px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span
                    style={{
                      display: "inline-block",
                      width: 24,
                      height: 24,
                      backgroundColor: "#EE4D2D",
                      borderRadius: 4,
                      textAlign: "center",
                      lineHeight: "24px",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: 12,
                    }}
                  >
                    S
                  </span>
                  <span className="text-muted">Shopee</span>
                </div>
                <div className="h4 mb-1" style={{ color: "#EE4D2D" }}>
                  {this.formatPrice(data.shopee.total_revenue)}
                </div>
                <div className="text-muted small">
                  <Badge color="light" className="mr-2">
                    {data.shopee.order_count} đơn
                  </Badge>
                </div>
              </div>
            </Col>

            {/* TikTok */}
            <Col md="4" className="mb-3">
              <div
                className="p-3 bg-tiktok-soft"
                style={{
                  borderRadius: "8px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span
                    style={{
                      display: "inline-block",
                      width: 24,
                      height: 24,
                      backgroundColor: "#000",
                      borderRadius: 4,
                      textAlign: "center",
                      lineHeight: "24px",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: 12,
                    }}
                  >
                    T
                  </span>
                  <span className="text-muted">TikTok Shop</span>
                </div>
                <div className="h4 mb-1">
                  {this.formatPrice(data.tiktok.total_revenue)}
                </div>
                <div className="text-muted small">
                  <Badge color="light" className="mr-2">
                    {data.tiktok.order_count} đơn
                  </Badge>
                </div>
              </div>
            </Col>

            {/* Total */}
            <Col md="4" className="mb-3">
              <div
                className="p-3 bg-success-soft"
                style={{
                  borderRadius: "8px",
                  borderLeft: "4px solid #4CAF50",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <i className="simple-icon-chart text-success" />
                  <span className="text-muted">Tổng cộng</span>
                </div>
                <div className="h4 mb-1 text-success">
                  {this.formatPrice(data.total.total_revenue)}
                </div>
                <div className="text-muted small">
                  <Badge color="light" className="mr-2">
                    {data.total.order_count} đơn
                  </Badge>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}

export default EcommerceAnalytics;
